import View                from '@widesk-ui/components/View';
import useDesignTokens     from '@/hooks/useDesignTokens';
import { POSITIONS }       from '@/TokamapEditor/ux/AreaSidebar/contentLabels';
import { POSITION_LABELS } from '@/TokamapEditor/ux/AreaSidebar/contentLabels';

const PositionGrid = ({ horizontal, vertical, onPick }: {
	horizontal?: number;
	vertical?: number;
	onPick: (horizontal: number, vertical: number) => void;
}) => {
	const tokens = useDesignTokens();

	return (
		<View
			p={6}
			br={8}
			style={{
				flexShrink: 0,
				display: 'grid',
				gridTemplateColumns: 'repeat(3, 32px)',
				gridTemplateRows: 'repeat(3, 32px)',
				gap: 4,
				border: `1px solid ${tokens.border.default}`,
			}}
		>
			{POSITIONS.map((v, row) => POSITIONS.map((h, column) => {
				const selected = h === horizontal && v === vertical;

				return (
					<button
						key={`${row}-${column}`}
						type="button"
						aria-label={POSITION_LABELS[row]![column]}
						aria-pressed={selected}
						onClick={() => onPick(h, v)}
						style={{
							border: 0,
							borderRadius: 5,
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							background: selected ? `color-mix(in srgb, ${tokens.color.primary} 12%, transparent)` : tokens.surface.subtle,
						}}
					>
						<span
							style={{
								width: 8,
								height: 8,
								borderRadius: '50%',
								background: selected ? tokens.color.primary : tokens.border.default,
							}}
						/>
					</button>
				);
			}))}
		</View>
	);
};

export default PositionGrid;
